var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReservationTakeUp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3337 11.7052V9.62462C13.3337 7.8377 13.3337 6.94424 12.8455 6.38911C12.3573 5.83398 11.5717 5.83398 10.0003 5.83398C8.42898 5.83398 7.6433 5.83398 7.15515 6.38911C6.66699 6.94424 6.66699 7.8377 6.66699 9.62462V11.7052C6.66699 12.9954 6.66699 13.6406 6.93888 13.9224C7.06855 14.0569 7.23223 14.1413 7.40659 14.1638C7.77218 14.2109 8.19912 13.786 9.05298 12.9364C9.43041 12.5609 9.61912 12.3731 9.83747 12.3236C9.94498 12.2992 10.0557 12.2992 10.1632 12.3236C10.3815 12.3731 10.5702 12.5609 10.9477 12.9364C11.8015 13.786 12.2285 14.2109 12.5941 14.1638C12.7684 14.1413 12.9321 14.0569 13.0618 13.9224C13.3337 13.6406 13.3337 12.9954 13.3337 11.7052Z",
    stroke: "#2058E7",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3337 9.99935C18.3337 14.6017 14.6027 18.3327 10.0003 18.3327C5.39795 18.3327 1.66699 14.6017 1.66699 9.99935C1.66699 5.39698 5.39795 1.66602 10.0003 1.66602C14.6027 1.66602 18.3337 5.39698 18.3337 9.99935Z",
    stroke: "#2058E7",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4056_19562"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReservationTakeUp);
export default __webpack_public_path__ + "static/media/ReservationTakeUp.050a1e862f240c4af762782960ea0d5a.svg";
export { ForwardRef as ReactComponent };